import { render } from "./ReportMini.vue?vue&type=template&id=0c82984e"
import script from "./ReportMini.vue?vue&type=script&lang=js"
export * from "./ReportMini.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__